import React from 'react';
import './index.module.less';

interface IProps {
  type?: 'common' | 'device';
  title?: string | React.ReactNode;
  desc?: string | React.ReactNode;
  button?: string | React.ReactNode;
  onClickButton?: () => void;
}

const EmptyView = (props: IProps) => {
  const {
    type = 'common',
    title = '这里空空的哎~',
    desc,
    button,
    onClickButton
  } = props;

  return (
    <div styleName="container">
      <div styleName={`image type-${type}`}></div>
      <div styleName="title">{title}</div>
      { desc && <div styleName="desc">{desc}</div> }
      { button && <div styleName="button" onClick={onClickButton}>{button}</div> }
    </div>
  );
}

export default EmptyView;